import { DirectiveBinding } from "vue"

export default {
  beforeMount(el: HTMLElement, binding: DirectiveBinding) {
    toggleVisibility(el, binding.value)
  },
  updated(el: HTMLElement, binding: DirectiveBinding) {
    toggleVisibility(el, binding.value)
  },
}

function toggleVisibility(el: HTMLElement, value: DirectiveBinding) {
  if (value) {
    el.classList.remove('invisible')
    el.classList.add('visible')
  } else {
    el.classList.remove('visible')
    el.classList.add('invisible')
  }
}
